<template>
    <div class="rel p:1 z:10 w:full {content:'';abs;bg:linear-gradient(290.86deg,rgba(248,195,233,0.99)|0%,#C1DDFF|25.49%,#CAE3F3|78.2%,#EFE8AC|100.77%);w:100%;h:100%;top:0;left:0;z:-1;r:100}::before {r:20}::before@<sm">
        <div class="r:100 p:16|32 bg:#E0EAFF {r:20;p:12|16}@<sm">
            <form action="." class="flex px:16 r:8 bg:white" @submit.prevent="search">
                <input class="flex:1 py:16 outline:none" :id="id" placeholder="輸入學校, 課程, 或授課老師" type="search" v-model.trim="info.target" />
                <img alt="" class="inline w:20 ml:8 cursor:pointer" @click="search" src="image/icon_header_search.svg" />
            </form>
        </div>
    </div>
</template>

<script setup>
    const id = nextId();
    const info = useSearchInfo();

    const emit = defineEmits(["search"]);

    const search = () => {
        emit("search");
    }
</script>
